import { BrowserRouter, NavLink, Route, Routes } from 'react-router-dom';
import { GlobalStyles } from '@soluto-private/mx-asurion-ui-react';
import './app.css';
import { WidgetDocs } from './widgetDocs';

const STORYBOOK_URL = window.location.hostname === 'localhost' ? 'http://localhost:6006' : 'storybook/index.html';

const basename = new URL(document.baseURI).pathname.replace(/\/$/, '');

const navStyle: React.CSSProperties = {
  display: 'flex',
  gap: '1rem',
  padding: '0.75rem 1.5rem',
  borderBottom: '1px solid #e0e0e0',
  fontFamily: 'sans-serif',
  background: '#fff',
};

const linkStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
  textDecoration: 'none',
  fontWeight: isActive ? 700 : 400,
  color: isActive ? '#000' : '#555',
  borderBottom: isActive ? '2px solid #000' : '2px solid transparent',
  paddingBottom: 4,
});

export function App() {
  return (
    <BrowserRouter basename={basename}>
      <GlobalStyles />
      <nav style={navStyle}>
        <NavLink to="/" end style={linkStyle}>
          Playground
        </NavLink>
        <NavLink to="/storybook" style={linkStyle}>
          Storybook
        </NavLink>
      </nav>
      <main>
        <Routes>
          <Route path="/" element={<WidgetDocs />} />
          <Route
            path="/storybook/*"
            element={
              <iframe
                src={STORYBOOK_URL}
                style={{ width: '100%', height: 'calc(100vh - 49px)', border: 'none', display: 'block' }}
                title="Storybook"
              />
            }
          />
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
